import React from "react";
import styles from "./alarm-list-toolbar.module.scss";
import { FlexRowContainer } from "@src/components/templates/layouts/flex-row-container/flex-row-container";
import { ButtonWithIcon } from "@src/components/atoms/buttons/button-with-icon/button-with-icon";
import envelopeIcon from "@src/assets/svg/envelope.svg";
import alarmProfileIcon from "@src/assets/svg/alarm-profile.svg";
import { useDispatch, useSelector } from "react-redux";
import { updateModalsCloseDrawerModal } from "@src/reducers/your-reducer";
import { AlarmRow } from "@src/cloud-connect/alarms/entities/alarm-row";
import { RootState } from "@src/reducers/store";
import { useI18N } from "@src/language/language-context";

const cssClassName = "alarm-list-toolbar";

interface AlarmListToolbarPropTypes {
  arrayOfAlarmRows: AlarmRow[];
}

export const AlarmListToolbar = ({
  arrayOfAlarmRows,
}: AlarmListToolbarPropTypes) => {
  const dispatch = useDispatch();
  const i18n = useI18N();
  const authContext = useSelector(
    (state: RootState) => state.yourSlice.authContext,
  );

  const texts = {
    addRecipients: i18n("modules.alarmListToolbar.addRecipients"),
    viewRecipients: i18n("modules.alarmListToolbar.viewRecipients"),
    createAlarmProfile: i18n("modules.alarmListToolbar.createAlarmProfile"),
    viewAlarmProfiles: i18n("modules.alarmListToolbar.viewAlarmProfiles"),
    searchHint: i18n("modules.alarmListToolbar.searchHint"),
  };

  const openAlarmProfileEmailRecipientsDrawer = () => {
    dispatch(
      updateModalsCloseDrawerModal({
        showModal: true,
        id: "alarmProfileEmailRecipientsDrawerModal",
      }),
    );
  };

  const openAlarmProfilesDrawer = () => {
    dispatch(
      updateModalsCloseDrawerModal({
        showModal: true,
        id: "alarmProfilesDrawerModal",
      }),
    );
  };

  const returnViewerOrManagerTextForRecipients = (
    managerText: string,
    viewerText: string,
  ) => {
    if (
      authContext &&
      authContext.permissions.includes("manage-condition-monitoring")
    ) {
      return managerText;
    } else {
      return viewerText;
    }
  };

  const returnViewerOrManagerTextForAlarmProfiles = (
    managerText: string,
    viewerText: string,
  ) => {
    if (
      authContext &&
      authContext.permissions.includes("manage-condition-monitoring")
    ) {
      return managerText;
    } else {
      return viewerText;
    }
  };

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__filter-icon-wrapper`]}>
        {/*         <FilterIcon /> */}
        <div className={styles[`${cssClassName}__search-hint`]}>
          {texts.searchHint}
        </div>
      </div>
      <FlexRowContainer horizontalGap={8} justifyContent="center">
        <ButtonWithIcon
          variant={
            typeof arrayOfAlarmRows === "undefined"
              ? ["no-outline", "color-blue", "no-outline-disabled"]
              : ["no-outline", "color-blue"]
          }
          fun={openAlarmProfileEmailRecipientsDrawer}
          icon={envelopeIcon}
          text={returnViewerOrManagerTextForRecipients(
            texts.addRecipients,
            texts.viewRecipients,
          )}
          disabled={typeof arrayOfAlarmRows === "undefined"}
        />
        <ButtonWithIcon
          variant={
            typeof arrayOfAlarmRows === "undefined"
              ? ["no-outline", "color-blue", "no-outline-disabled"]
              : ["no-outline", "color-blue"]
          }
          fun={openAlarmProfilesDrawer}
          icon={alarmProfileIcon}
          text={returnViewerOrManagerTextForAlarmProfiles(
            texts.createAlarmProfile,
            texts.viewAlarmProfiles,
          )}
          disabled={typeof arrayOfAlarmRows === "undefined"}
        />
      </FlexRowContainer>
      <div />
    </div>
  );
};
